<template>
  <div>Not found.</div>
</template>

<script>
export default {};
</script>

<style></style>
